module.exports = "<div class=\"mb-5\">\n  <h1 [ngStyle]=\"{margin:margin, fontSize: fontSize}\">\n    {{title}}\n  </h1>\n</div>"